/// <reference path="../../typings/tsd.d.ts" /> 

module warsApp.services {

    export class UserAdministrationService {
        
        public apiBaseRoute = "./api/UserAdministration/";
        
        constructor(
            private $http: ng.IHttpService,
            private $q: angular.IQService)
        {
            
        }

        public getUsers(userProviders): angular.IPromise<any> {
            var self = this;
            var d = this.$q.defer();
            var tags = Enumerable.from(userProviders).select(i => (<any>i).tag).toArray();
            this.$http.post(self.apiBaseRoute + "GetUsers", {providers: tags}).then(result => {
                d.resolve(result.data);
            });
            return d.promise;
        }

        public getUserGrantAuthorizations(): angular.IPromise<any> {
            var self = this;
            var d = this.$q.defer();
            this.$http.get(self.apiBaseRoute + "GetUserGrantAuthorizations").then(result => {
                d.resolve(result.data);
            });
            return d.promise;
        }

        public getUserProviders(): angular.IPromise<any> {
            var self = this;
            var d = this.$q.defer();
            this.$http.get(self.apiBaseRoute + "GetUserProviders").then(result => {
                d.resolve(result.data);
            });
            return d.promise;
        }

        public addUser(user): angular.IPromise<any> {
            var self = this;
            var d = this.$q.defer();
            this.$http.post(self.apiBaseRoute + "AddUser", user).then(result => {
                d.resolve(result.data);
            });
            return d.promise;
        }

        public removeClaim(claimId): angular.IPromise<any> {
            var self = this;
            var d = this.$q.defer();
            this.$http.post(self.apiBaseRoute + "RemoveClaim", { claimId: claimId }).then(result => {
                d.resolve(result.data);
            });
            return d.promise;
        }

        public addUserNewClaim(user): angular.IPromise<any> {
            var self = this;
            var d = this.$q.defer();
            this.$http.post(self.apiBaseRoute + "AddUserNewClaim", user).then(result => {
                d.resolve(result.data);
            });
            return d.promise;
        }
        
    }
}

warsApp.registerService('UserAdministrationService', ['$http', '$q']);